module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust4_m_en.7302bc10242a93f0e55af03217cb23a4.png";